export enum VisitReason {
  BETTER_RATE = 'better_rate',
  NEW_CAR = 'new_car',
  SHOPPING_AROUND = 'shopping_around',
}
